import axios from 'axios';
import {backendHost} from '../../config';

export const postPartnerBalanceCorrection = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/partners/correction`, params);
};